import dayjs from 'dayjs'
import ptBR from 'dayjs/locale/pt-br'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import format from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

const date = dayjs

date.extend(format)
date.extend(utc)
date.extend(timezone)
date.extend(relativeTime)
date.extend(advancedFormat)
date.locale(ptBR)

date.tz.setDefault('America/Sao_Paulo')

export default date

export function getDifferenceInDays(start: Date, end: Date) {
  const diff = start.getTime() - end.getTime()

  return Math.ceil(diff / (1000 * 60 * 60 * 24))
}
